import { createRouter, createWebHistory } from '@ionic/vue-router';
import MainView from '@/views/MainView.vue';
import DemoView from '@/views/DemoView.vue';
import VisitorMGR from '@/views/VisitorMGR.vue';
import { getStorageUri } from '@/config/cdn';

const routes = [
  {
    path: '/',
    redirect: '/achievements'
  },
  {
    path: '/achievements',
    name: 'Achievements',
    component: MainView,
    props: {
      domain: 'BA',
      storageUri: getStorageUri()
    }
  },
  {
    path: '/app',
    name: 'AppAchievements',
    component: MainView,
    props: {
      domain: 'BA',
      storageUri: getStorageUri(),
      isApp: true
    }
  },
  {
    path: '/visitor',
    name: 'VisitorMGR',
    component: VisitorMGR
  },
  {
    path: '/chatbot',
    name: 'ChatBot',
    component: DemoView,
    props: {
      domain: 'BA',
      storageUri: getStorageUri(),
      isApp: true
    }
  }
];

const router = createRouter({
  history: createWebHistory('/app/'), // Add base URL here
  routes
});

export default router;
